// 自動生成 = scripts/render_parry_pitch_sound.py (手で直さない・直したら素材と一緒に書き出し直す)。
// 案 (p|q|r) → "重さの段:連続の段 (崩した瞬間は broke)" → 鳴らす層 (WAV・再生の速さ・WAV に掛ける倍率) と、
// 今の柳の型 (gainDb -8 で鳴らした時) を 0dB とした大きさの見積もり relDb。ゲームでは gain に柳の型の gainDb (-8) を重ねて鳴らす。
export const PARRY_PITCH_PLAN = {
 "fileGainDb": 0.0,
 "refM400": -14.0,
 "variants": {
  "p": {
   "light:1": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 0.871
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.871
     }
    ],
    "relDb": -1.2
   },
   "light:2": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 0.9264
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.12246,
      "gain": 0.9264
     }
    ],
    "relDb": -0.95
   },
   "light:3": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 0.9797
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.25992,
      "gain": 0.9797
     }
    ],
    "relDb": -0.7
   },
   "light:4": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 1.0449
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 1.0449
     }
    ],
    "relDb": -0.45
   },
   "light:5": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 1.0932
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.68179,
      "gain": 1.0932
     }
    ],
    "relDb": -0.2
   },
   "light:broke": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 1.2946
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.0,
      "gain": 0.9709
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.51984,
      "gain": 0.5826
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.99661,
      "gain": 0.6473
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.5826
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.7767
     }
    ],
    "relDb": 2.0
   },
   "mid:1": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 0.9039
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.9039
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5423
     }
    ],
    "relDb": -0.5
   },
   "mid:2": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 0.9322
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.8409,
      "gain": 0.9322
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5593
     }
    ],
    "relDb": -0.25
   },
   "mid:3": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 0.9794
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.9794
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5877
     }
    ],
    "relDb": 0.0
   },
   "mid:4": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 1.0378
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.12246,
      "gain": 1.0378
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.6227
     }
    ],
    "relDb": 0.25
   },
   "mid:5": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 1.1011
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.25992,
      "gain": 1.1011
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.6607
     }
    ],
    "relDb": 0.5
   },
   "mid:broke": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 1.335
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.0,
      "gain": 1.0012
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.51984,
      "gain": 0.6007
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.99661,
      "gain": 0.6675
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.6007
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.801
     }
    ],
    "relDb": 2.0
   },
   "heavy:1": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.8894
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.8894
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.8894
     }
    ],
    "relDb": 0.3
   },
   "heavy:2": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.9148
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.56123,
      "gain": 0.9148
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.9148
     }
    ],
    "relDb": 0.55
   },
   "heavy:3": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.9417
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.62996,
      "gain": 0.9417
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.9417
     }
    ],
    "relDb": 0.8
   },
   "heavy:4": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.9962
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.9962
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.9962
     }
    ],
    "relDb": 1.05
   },
   "heavy:5": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 1.0249
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.8409,
      "gain": 1.0249
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 1.0249
     }
    ],
    "relDb": 1.3
   },
   "heavy:broke": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 1.2021
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.0,
      "gain": 0.9016
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.51984,
      "gain": 0.541
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.99661,
      "gain": 0.6011
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.541
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 1.2021
     }
    ],
    "relDb": 2.0
   }
  },
  "q": {
   "light:1": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 0.871
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.871
     }
    ],
    "relDb": -1.2
   },
   "light:2": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 0.8823
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.5294
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.8823
     }
    ],
    "relDb": -0.95
   },
   "light:3": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 0.8971
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.3806
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.3806
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.25992,
      "gain": 0.8971
     }
    ],
    "relDb": -0.7
   },
   "light:4": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 0.9844
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.341
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.341
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.25992,
      "gain": 0.341
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.0,
      "gain": 0.9844
     }
    ],
    "relDb": -0.45
   },
   "light:5": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 1.0622
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.3186
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.3186
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.25992,
      "gain": 0.3186
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.0,
      "gain": 0.3186
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.51984,
      "gain": 1.0622
     }
    ],
    "relDb": -0.2
   },
   "light:broke": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 1.0,
      "gain": 1.3206
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.3544
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.3544
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.3544
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.0,
      "gain": 0.3544
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.51984,
      "gain": 0.3544
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.99661,
      "gain": 1.3206
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.7924
     }
    ],
    "relDb": 2.0
   },
   "mid:1": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 0.9039
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.9039
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5423
     }
    ],
    "relDb": -0.5
   },
   "mid:2": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 0.8852
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.5311
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.12246,
      "gain": 0.8852
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5311
     }
    ],
    "relDb": -0.25
   },
   "mid:3": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 0.895
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.3797
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.12246,
      "gain": 0.3797
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.94387,
      "gain": 0.895
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.537
     }
    ],
    "relDb": 0.0
   },
   "mid:4": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 0.9892
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.3427
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.12246,
      "gain": 0.3427
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.94387,
      "gain": 0.3427
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.9892
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5935
     }
    ],
    "relDb": 0.25
   },
   "mid:5": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 1.0607
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.3182
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.12246,
      "gain": 0.3182
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.94387,
      "gain": 0.3182
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.3182
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.88775,
      "gain": 1.0607
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.6364
     }
    ],
    "relDb": 0.5
   },
   "mid:broke": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.94387,
      "gain": 1.3554
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.3637
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.3637
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.3637
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.0,
      "gain": 0.3637
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.51984,
      "gain": 0.3637
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.99661,
      "gain": 1.3554
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.8132
     }
    ],
    "relDb": 2.0
   },
   "heavy:1": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.8894
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.8894
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.8894
     }
    ],
    "relDb": 0.3
   },
   "heavy:2": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.8586
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.5152
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.8586
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.8586
     }
    ],
    "relDb": 0.55
   },
   "heavy:3": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.8735
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.3706
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.3706
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.62996,
      "gain": 0.8735
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.8735
     }
    ],
    "relDb": 0.8
   },
   "heavy:4": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.9173
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.3177
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.3177
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.62996,
      "gain": 0.3177
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.9173
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.9173
     }
    ],
    "relDb": 1.05
   },
   "heavy:5": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 0.9873
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.2962
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.74915,
      "gain": 0.2962
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.62996,
      "gain": 0.2962
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.2962
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.25992,
      "gain": 0.9873
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.9873
     }
    ],
    "relDb": 1.3
   },
   "heavy:broke": {
    "layers": [
     {
      "sample": "parry_pitch_body",
      "rate": 0.8909,
      "gain": 1.222
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 0.5,
      "gain": 0.3279
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.0,
      "gain": 0.3279
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 1.49831,
      "gain": 0.3279
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.0,
      "gain": 0.3279
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.51984,
      "gain": 0.3279
     },
     {
      "sample": "parry_pitch_ring",
      "rate": 2.99661,
      "gain": 1.222
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 1.222
     }
    ],
    "relDb": 2.0
   }
  },
  "r": {
   "light:1": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.0,
      "gain": 0.871
     }
    ],
    "relDb": -1.2
   },
   "light:2": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.05946,
      "gain": 0.9628
     }
    ],
    "relDb": -0.95
   },
   "light:3": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.12246,
      "gain": 1.0167
     }
    ],
    "relDb": -0.7
   },
   "light:4": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.18921,
      "gain": 1.074
     }
    ],
    "relDb": -0.45
   },
   "light:5": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.25992,
      "gain": 1.1352
     }
    ],
    "relDb": -0.2
   },
   "light:broke": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.33484,
      "gain": 1.3943
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.8366
     }
    ],
    "relDb": 2.0
   },
   "mid:1": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 0.8909,
      "gain": 0.9056
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5434
     }
    ],
    "relDb": -0.5
   },
   "mid:2": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 0.94387,
      "gain": 0.9502
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5701
     }
    ],
    "relDb": -0.25
   },
   "mid:3": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.0,
      "gain": 0.9487
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.5692
     }
    ],
    "relDb": 0.0
   },
   "mid:4": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.05946,
      "gain": 1.038
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.6228
     }
    ],
    "relDb": 0.25
   },
   "mid:5": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.12246,
      "gain": 1.0899
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.654
     }
    ],
    "relDb": 0.5
   },
   "mid:broke": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.33484,
      "gain": 1.3943
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.8366
     }
    ],
    "relDb": 2.0
   },
   "heavy:1": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 0.7937,
      "gain": 0.8983
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.8983
     }
    ],
    "relDb": 0.3
   },
   "heavy:2": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 0.8409,
      "gain": 0.9344
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.9344
     }
    ],
    "relDb": 0.55
   },
   "heavy:3": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 0.8909,
      "gain": 0.972
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 0.972
     }
    ],
    "relDb": 0.8
   },
   "heavy:4": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 0.94387,
      "gain": 1.0195
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 1.0195
     }
    ],
    "relDb": 1.05
   },
   "heavy:5": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.0,
      "gain": 1.0192
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 1.0192
     }
    ],
    "relDb": 1.3
   },
   "heavy:broke": {
    "layers": [
     {
      "sample": "parry_yanagi",
      "rate": 1.33484,
      "gain": 1.258
     },
     {
      "sample": "parry_pitch_heavy",
      "rate": 1.0,
      "gain": 1.258
     }
    ],
    "relDb": 2.0
   }
  }
 }
} as const
